const darkTheme = {
  mode: "dark",
  colors: {
    white: "#303030",
    black: "#222222",
    brandSuccess: "#a6c733",
    brandInfo: "#57bdda",
    brandWarning: "#e5c649",
    brandDanger: "#ed7878",
    primary: "#2A844E", //verde
    tertiary: "#E1E1E1",
    disabledDaysWeek: "#252424",
    secondary: "#48A46D",
    borderGradient: "conic-gradient(from 90deg at 50% 50%, #48A46D 0deg, #2A844E 91.73076510429382deg, #4DE889 190.38461208343506deg, #48A46D 289.03846979141235deg, #2A844E 360deg)",
    alert: "#FF6E28", //laranja
    placeholder: "#939090",
    elements: "#434343",
    modal: "#242526",
    background2: "#242526",
    mockup: "#D9D9D9",
    skeleton1: "#242526",
    skeleton2: "#303030",
    disable: "#626262",
    dashBorderDown: '#C92A2A',
    dashBorderUp: '#34C759',
    dashBgDown: '#8b3f3f73',
    dashBgUp: '#477f5873'
  },
};

export default darkTheme;
